/**
 * 使用的老接口
 */

import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

export enum LEARN_STATUS {
    LEARNED = 1, // 已经学完
    TO_LEARNER = 2, // 待完成
}

export enum TASK_TYPE {
    COURSE = 0,
    PROGRAM = 1,
}

export interface IInput {
    learn_status: LEARN_STATUS;
    size: number;
    page?: number;
}

export interface IRankInfo {
    rank: number;
    total_points: number;
}

export interface IAssignmentInfo {
    task_type: TASK_TYPE;
    learn_status: LEARN_STATUS;

    assign_url: string;
    finish_count: number;
    finish_ratio: number;
    finish_time: number;
    unfinish_task_num: string;
    over_due: number;
    due_time: number;
    participate: string;

    title: string;
    group_id: string;
    group_num: number;
    program_id: string;
    stage_num: number;
    session_num: number;
    session_url: string;
    share_card_view: string;
    share_qrc: string;
    show_pic: string;

    teacher_avatar: string;
    teacher_avatar_arr: string[];
    teacher_id: number;
    teacher_name: number;
    expired_access: number;
}

interface RestCourseIsCloseParams {
    /** 任务类型 0课程 1学习项目 */
    task_type: 0 | 1;
    /** 资源id。如：分组对应的group_id */
    id: string;
}

interface RestCourseIsCloseResponse {
    is_notice_element_close: boolean;
    assign_url: string;
    learn_status: number;
    session_url: string;
}

export const getMyAssignmentList = (data: IInput): Promise<IList<IAssignmentInfo>> => {
    return fetchData(Api.MY_ASSIGNMENT_LIST, data).then((res: IListResponse<IAssignmentInfo>) => {
        return res.data;
    });
};

export const getRestCourseIsClose = (data: RestCourseIsCloseParams): Promise<RestCourseIsCloseResponse> => {
    return fetchData(Api.GET_NEED_NOTICE, data).then((res: IResponse<RestCourseIsCloseResponse>) => {
        return res.data;
    });
};
